import React from "react";
import Card from "../../../newComponents/card";
import CardPopUp from "../../../newComponents/cardPopUp";
import GeneralSection from "../../../newComponents/generalSection";

const mediaBlockGroup = ({ blocks, }) => (
  <GeneralSection>
    <div className="boxes swiper-container js-load-more js-slider-boxes-projects mb-4">
      <ul>
      {blocks.map((block, index) => {
      
      const featureImage = block.image[0];
      let aspectRatio;

      switch (block.imageAspectRatio) {
        case "2:1":
          aspectRatio = 2;
          break;
        case "16:9":
          aspectRatio = 16/9; 
          break;
        case "4:3":
          aspectRatio = 4/3;
          break;
        case "3:2":
          aspectRatio = 3/2;
          break;
        case "1:1":
          aspectRatio = 1;
          break;
        default:
          aspectRatio = false;
          break;
      }

      if(!aspectRatio && !featureImage) aspectRatio = 2;

      return (
        block.popUpModalContent ?
          <CardPopUp key={`media-block-group-${block.id}-item-${index}`} useImage={block.showPlaceholderImage} image={featureImage} ar={aspectRatio || featureImage.width / featureImage.height} title={block.titleText} subtitle={block.summaryText} readMoreLabel={block.linkText} modalTitle={block.titleText} truncateText={block.truncateText}>
            <div className="prose max-w-none mb-4 body-content-rich-text-bullets" dangerouslySetInnerHTML={{ __html: block.popUpModalContent, }}/>
          </CardPopUp>
          :
          <Card key={`media-block-group-${block.id}-item-${index}`} useImage={block.showPlaceholderImage} image={featureImage} ar={aspectRatio || featureImage.width / featureImage.height} title={block.titleText} subtitle={block.summaryText} href={block.customUrl} readMoreLabel={block.linkText} truncateText={block.truncateText}/>
      );
    })}
      </ul>
      <div className="swiper-pagination boxes__pagination" />
    </div>
  </GeneralSection>
);

export default mediaBlockGroup;